import { startRovoStreamingPresence } from '@databases/database-ai-first-creation-state';
import { initDatabasesRovoContentBridge } from '@databases/rovo-bridge';

import { type Recyclable } from './types.ts';

export function initializeDatabasesRovoBridge(): Recyclable {
  let teardown: (() => void) | undefined;
  let stopStreamingPresence: (() => void) | undefined;

  return {
    setup(contentId: string) {
      ({ teardown } = initDatabasesRovoContentBridge(contentId));
      // Bridge Rovo AI-first-creation streaming state into the presence store
      // (shows the Rovo participant on the field/entry being processed).
      stopStreamingPresence = startRovoStreamingPresence();
    },
    dispose() {
      teardown?.();
      teardown = undefined;
      stopStreamingPresence?.();
      stopStreamingPresence = undefined;
    },
  };
}
